import { createFileRoute } from "@tanstack/react-router";
import { PlatformPage } from "@/components/PlatformPage";
import { obsluga } from "@/lib/integrations-data";
import { buildSeoMeta } from "@/lib/seo";

const PATH = "/integracje/obsluga";

export const Route = createFileRoute("/integracje/obsluga")({
  head: () =>
    buildSeoMeta({
      title: "Obsługa klienta: Zendesk, LiveChat, Intercom, Tidio | SyncTech",
      description:
        "Wdrożenia systemów obsługi klienta: Zendesk, LiveChat, Intercom, Tidio, Freshdesk. Integracja z Baselinker, czatboty, centralna inbox. Niższy czas obsługi o 40-60%.",
      path: PATH,
    }),
  component: () => <PlatformPage data={obsluga} path={PATH} breadcrumbCategory="Integracje" />,
});
